import script from "./settings-tab.vue?vue&type=script&setup=true&lang=js"
export * from "./settings-tab.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__